import { blue, blueGrey, common, grey } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';

import { BRONZE, GOLD, MECHA_METAL, PLATINUM } from './configs/colours';

export const theme = createTheme({
  typography: {
    // fontSize: 12,
    allVariants: {
      color: grey[900],
    },
  },
  palette: {
    primary: {
      light: blue[400],
      main: blue[500],
      dark: blue[600],
    },
    secondary: {
      light: blueGrey[400],
      main: blueGrey[500],
      dark: blueGrey[600],
    },
    neutral: {
      light: grey[400],
      main: grey[500],
      dark: grey[600],
      contrastText: common.black,
    },
    tertiary: {
      light: grey[300],
      main: grey[400],
      dark: grey[500],
      contrastText: common.black,
    },
    text: {
      primary: grey[900],
      secondary: grey[600],
    },
    luxPlus: {
      main: '#304DAB',
      contrastText: common.white,
      light: '#5DA4FA',
      dark: '#0F1C47',
    },
    loyaltyTiers: {
      bronze: {
        main: BRONZE[300],
        contrastText: common.black,
        light: BRONZE[100],
        dark: BRONZE[500],
        gradient: `linear-gradient(45deg, ${BRONZE[300]} 0.73%, ${BRONZE[100]} 45.77%, ${BRONZE[300]} 74.49%)`,
      },
      silver: {
        main: MECHA_METAL[300],
        contrastText: common.black,
        light: MECHA_METAL[100],
        dark: MECHA_METAL[500],
        gradient: `linear-gradient(45deg, ${MECHA_METAL[300]} 0.73%, ${MECHA_METAL[100]} 45.77%, ${MECHA_METAL[300]} 74.49%)`,
      },
      gold: {
        main: GOLD[300],
        contrastText: common.black,
        light: GOLD[100],
        dark: GOLD[500],
        gradient: `linear-gradient(45deg, ${GOLD[300]} 0.73%, ${GOLD[100]} 45.77%, ${GOLD[300]} 74.49%)`,
      },
      platinum: {
        main: PLATINUM[600],
        contrastText: common.white,
        light: PLATINUM[400],
        dark: PLATINUM[700],
        gradient: `linear-gradient(45deg, ${PLATINUM[900]} 0.73%, ${PLATINUM[600]} 45.77%, ${PLATINUM[900]} 74.49%)`,
      },
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        text: {
          userSelect: 'text',
        },
      },
    },

    MuiInputBase: {
      defaultProps: {
        size: 'small',
      },
    },

    MuiFormControl: {
      defaultProps: {
        size: 'small',
      },
    },

    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },

    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
    },

    MuiAutocomplete: {
      defaultProps: {
        size: 'small',
        slotProps: {
          paper: {
            elevation: 1,
          },
        },
      },
    },

    MuiDataGrid: {
      styleOverrides: {
        root: {
          border: 'none',
          fontSize: '1rem',
        },
        columnHeaders: {
          background: grey[200],
        },
        row: {
          cursor: 'pointer',
        },
        cell: {
          paddingBottom: 3,
          paddingTop: 3,
        },
      },
    },
    /*
    MuiInputLabel: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          transform: ownerState.shrink ? 'translate(14px, -10px) scale(0.9)' : 'translate(14px, 10px) scale(1)',
        }),
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        inputRoot: {
          padding: '10px 14px',
        },
        input: {
          padding: '0 !important',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '10px 14px',
        },
        notchedOutline: {
          '& legend': {
            fontSize: '0.9em',
          },
        },
      },
    },
    */
  },
});
